export const mapNonNullValuesByKey = <
  CT extends Record<string, any>,
  IT extends Record<string, any>
>({
  currentObj,
  incomingObj,
}: {
  currentObj: CT;
  incomingObj: IT;
}): CT => {
  const result: CT = structuredClone(currentObj);

  Object.keys(currentObj).forEach((key) => {
    if (key in incomingObj && incomingObj[key] !== null) {
      result[key as keyof CT] = incomingObj[key] as CT[keyof CT];
    }
  });

  return result;
};
